naiveShouldComponentUpdate = require 'app/scripts/lib/util/naive-should-component-update'
React = require 'react'
t = require('app/scripts/views/internal/recup-with-helpers')('member')

module.exports = class MemberAvatar extends React.Component
  displayName: 'MemberAvatar'

  constructor: (props) ->
    super(props)

  shouldComponentUpdate: naiveShouldComponentUpdate

  render: t.renderable ->
    { avatarUrl, email, username, fullName, initials, isDeactivated, isBoardAdmin, isOrganizationAdmin, onClick, viewTitle } = @props
    t.div '.autocomplete-member-avatar', ->
      title = viewTitle
      if avatarUrl
        avatarUrl1x = [avatarUrl, '30.png'].join('/')
        avatarUrl2x = [avatarUrl, '50.png'].join('/')
        t.img {
          class: 'member-avatar'
          height: '30'
          width: '30'
          src: avatarUrl1x
          srcSet: "#{avatarUrl1x} 1x, #{avatarUrl2x} 2x"
          alt: title
          title
        }
      else if initials != ''
        t.span '.member-initials', { title }, ->
          t.text initials
      else if username?
        t.div '.member-icon-container', ->
          t.icon 'member'
      else if email?
        t.span '.member-initials', { title }, ->
          t.text email[0].toUpperCase()


      if !isDeactivated
        if isBoardAdmin
          t.span '.member-type.admin', { title: t.l('this-member-is-an-admin-of-this-board') }
        if isOrganizationAdmin
          t.span '.member-type.admin', { title: t.l('this-member-is-an-admin-of-this-organization') }

      t.span '.member-gold-badge', { title: t.l('this-member-has-trello-gold') }
